import React, { Component } from 'react';

export default class NotFound extends Component {
  render() {
    return (
      <div className="not-found jumbotron">
        <h1>Page Not Found</h1>
        <p>The content you are looking for could not be found</p>
        <p>
          <button className="btn btn-lg" type="button" onClick={() => this.props.history.goBack()}>
            Go back
          </button>
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NotFound/NotFound.js